import { profile } from "@shared/api/services"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "react-toastify"

export const useSendReceipt = () => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: (data) => profile.sendReceipt(data),
    onSuccess: () => {
      queryClient.invalidateQueries(['profile'])
			queryClient.invalidateQueries(['payouts'])
			queryClient.invalidateQueries(['orders'])
			toast.success('Чек отправлен')
    },
		retry: 0
  })

	return mutation
}
